<template>
  <div id="vue-app">
    <div
      data-swiftype-index="true"
      class="entry-content"
    >
      <!-- Trashday -->
      <section class="mtl">
        <div class="row mtl">
          <div class="large-24 columns">
            <TrashInput 
              :undetermined="undetermined"
              :delay="delay"
              :holidays="holidays"
            />
            <TrashTable
              :holidays="holidays"
            />
          </div>
        </div>
      </section>
      <!-- Trashday -->
    </div> <!-- End .entry-content -->
  </div>
</template>

<script>
import axios from 'axios';
import TrashTable from './components/TrashTable.vue';
import TrashInput from './components/TrashInput.vue';
import Moment from 'moment';
import { extendMoment } from 'moment-range';
const moment = extendMoment(Moment);

export default {
  name: 'App',
  components: {
    TrashInput,
    TrashTable,
  },
  data () {
    return {
      holidays: [],
      undetermined: false,
      delay: false,
      status: null,
      api: {
        url: process.env.VUE_APP_API_URL,
      },
    };
  },
  created () {
    let vm = this;
    vm.init();
  },
  methods: {
    getHolidays () {
      let vm = this;
      vm.holidays = [];
      return axios.get( vm.api.url )
        .then(async (result) => {
          result.data.holidays.forEach( function(holiday) {
            holiday['Holiday observed'] = holiday['holiday_label'] + ' – ' + moment(holiday['start_date']).format('dddd, MMMM D, YYYY');
            holiday['end_date'] = vm.setEndDate(holiday['start_date']);
            vm.holidays.push(holiday);
          });
          vm.undetermined = result.data.undetermined;
          vm.delay = result.data.delay;
          vm.status = result.data.status;
          return true;
        }).catch(() => {
          return false;
        });
    },
    setEndDate( startDate ) {
      // if holiday occurs weekend, don't do anything
      if( moment(startDate).weekday() == 6 || moment(startDate).weekday() == 0 ) {
        return startDate;
      }
      // else, set day to saturday to catch mon-friday collection days
      return moment(startDate).isoWeekday( 6 );
    },
    async init () {
      let vm = this;
      await vm.getHolidays();
    },
  },
};
</script>